import React, { useState } from 'react'
import Input from '../store/Input';
import axios from 'axios';
import "./FormularView.css";


import Spinner from '../images/spinner.svg';
import CheckIcon from '../images/CheckIcon';
import AirplaneIcon from '../images/AirplaneIcon';
import Hello from '../images/Hello';
import Mail from '../images/Mail';
import Phone from '../images/Phone';

function FormularView({SelectedQuestion}) {

    //const valueSelectedQuestion = SelectedQuestion.toString();
    const valueSelectedQuestion = SelectedQuestion;
    const [isLoading, setIsLoading] = useState(false);
    const [sendDataSuccess, setSendDataSuccess] = useState(false);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        name: "",
        mail: "",
        phone: "",
        subject: JSON.stringify(valueSelectedQuestion),
    })

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({...formData, [name]: value});
        setErrors({ ...errors, [name]: "" });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = {};
        const formDataObj = new FormData();
        
        if (formData.name.trim() === "") {
            validationErrors.name = "Bitte ausfüllen!";
        }
        if (formData.mail.trim() === "") {
            validationErrors.mail = "Bitte ausfüllen!";
        }
        if (formData.phone.trim() === "") {
            validationErrors.phone = "Bitte ausfüllen!";
        }

        formDataObj.append('name', formData.name);
        formDataObj.append('mail', formData.mail);
        formDataObj.append('phone', formData.phone);
        formDataObj.append('subject', formData.subject);
    
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        }else{
            setIsLoading(true);
            console.log(formData);
            axios({
                method: 'post',
                url: 'https://bewerbung.schwanfelder.de/backend/index.php',
                //headers: {'Content-Type': 'multipart/form-data' },
                //"Content-Type": "application/x-www-form-urlencoded"
                headers: {
                    'Content-Type': 'multipart/form-data',
                    "access-control-allow-origin": "*",
                    'Access-Control-Allow-Headers': 'Content-Type, Authorization',
                    'Access-Control-Allow-Methods': '*',
                },
                data: formDataObj
            }).then((response) => {
                if (response.status == '200') {
                    document.querySelector(".success").style.cssText = "display: block; text-align: center;";
                    setSendDataSuccess(true);
                    document.body.className += ' app-end';
                    window.scrollTo(0, 0);
                }else{
                    console.log('Nein');
                }
            }).catch((error) => {
                console.log('Error submittig from:', error);
                setIsLoading(false);
            })
        }
    }

    return (
        <>
            {!sendDataSuccess ? <div className="question-headline">Wie können wir Sie am besten erreichen?</div> : null}
            <form onSubmit={handleSubmit}>
                <div className="success display-none">Vielen Dank für Ihre Anfrage! <br />Wir melden uns schnellstmöglich bei Ihnen telefonisch oder per E-Mail.</div>
                {!sendDataSuccess &&
                <div className="form-input-handler">
                    <div className="form-input-item">
                        <div className="item-handler">
                            <label htmlFor="vorname">
                                Dein vollständiger Name
                                {errors.name && (
                                    <span className="validation-message">{errors.name}</span>
                                )}
                            </label>
                            <div className="item-handler-input max-input">
                                <i>
                                    <Hello />
                                </i>
                                <input 
                                    type="text" 
                                    id="name" 
                                    className="full-width" 
                                    name="name" 
                                    value={formData.name} 
                                    onChange={handleInputChange} 
                                 />
                                {/* <Input 
                                    type={"text"}
                                    id={"name"}
                                    classes={"full-width"}
                                    name={"name"}
                                /> */}
                            </div>
                        </div>
                        <div className="item-handler">
                            <label htmlFor="vorname">
                                Deine E-Mail Adresse
                                {errors.mail && (
                                    <span className="validation-message">{errors.mail}</span>
                                )}
                                </label>
                            <div className="item-handler-input max-input">
                                <i>
                                    <Mail />
                                </i>
                                <input 
                                    type="text" 
                                    id="mail" 
                                    className="full-width"
                                    name="mail" 
                                    value={formData.mail} 
                                    onChange={handleInputChange} 
                                />
                                {/* <Input 
                                    type={"text"}
                                    id={"mail"}
                                    classes={"full-width"}
                                    name={"mail"}
                                /> */}
                            </div>
                        </div>
                        <div className="item-handler">
                            <label htmlFor="vorname">
                                Deine Telefonnummer
                                {errors.phone && (
                                    <span className="validation-message">{errors.phone}</span>
                                )}
                            </label>
                            <div className="item-handler-input max-input">
                                <i>
                                    <Phone />
                                </i>
                                <input 
                                    type="text" 
                                    id="phone" 
                                    className="full-width" 
                                    name="phone" 
                                    placeholder=""
                                    value={formData.phone} 
                                    onChange={handleInputChange} 
                                />
                                {/* <Input 
                                    type={"text"}
                                    id={"phone"}
                                    classes={"full-width"}
                                    name={"phone"}
                                /> */}
                            </div>
                        </div>
                        <div>
                            <p>
                                Wir verarbeiten Ihre Daten zum Zwecke der Bearbeitung Ihrer Anfrage. Bitte beachten Sie unsere Datenschutzerklärung
                            </p>
                        </div>
                        <div>
                        <button type="submit" disabled={isLoading}>
                    {isLoading ? (
                    <div className="loader-html">
                        {!sendDataSuccess ? 
                            <div>Laden...</div>
                            : 
                            <i>
                                <CheckIcon/>
                            </i>
                            }
                        </div>
                        ) : (
                        "Bewerbung Senden"
                        )}
                    <i><AirplaneIcon/></i>
                </button>
                        </div>
                    </div>
                </div>
                }
            </form>
        </>
    )
}

export default FormularView
